import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../contexts/LanguageContext";

const IconHome = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
  </svg>
);

const IconMap = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 7.5l5.5-2.2 5 2.2L20 5v12.5l-5.5 2.2-5-2.2L4 20V7.5z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path d="M9.5 5.3v12.5M14.5 7.5v12.2" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

const IconHeart = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 20s-7-4.4-7-10a4.2 4.2 0 0 1 7-3 4.2 4.2 0 0 1 7 3c0 5.6-7 10-7 10z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
  </svg>
);

const IconProfile = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
    <circle cx="12" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M5 19.2c1.6-3 4-4.5 7-4.5s5.4 1.5 7 4.5"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

const ITEMS = [
  { to: "/homePage", key: "nav.home", Icon: IconHome },
  { to: "/map", key: "nav.discover", Icon: IconMap },
  { to: "/favourites", key: "nav.saved", Icon: IconHeart },
  { to: "/profile", key: "nav.profile", Icon: IconProfile },
];

const Footer = () => {
  const { t } = useLanguage();
  return (
    <Bar>
      {ITEMS.map(({ to, key, Icon }) => (
        <NavLink key={to} to={to} className={({ isActive }) => (isActive ? "active" : "")}>
          {({ isActive }) => (
            <Item $active={isActive}>
              <IconWrap $active={isActive}>
                <Icon />
              </IconWrap>
              <Label>{t(key)}</Label>
            </Item>
          )}
        </NavLink>
      ))}
    </Bar>
  );
};

export default Footer;

const Bar = styled.nav`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;

  a {
    text-decoration: none;
    color: inherit;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: ${(p) => (p.$active ? "inherit" : "inherit")};
  opacity: ${(p) => (p.$active ? 1 : 0.72)};
`;

const IconWrap = styled.span`
  width: 44px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: inherit;
`;

const Label = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
`;
